<app-header-menu></app-header-menu>

<mat-sidenav-container class="global-side-nav" [hasBackdrop]="false">
    <button type="button" class="burger-btn" [class.active]="drawer.opened" (click)="drawer.toggle()">
        <span></span>
    </button>
    <mat-sidenav
        #drawer
        [mode]="mobileQuery.matches ? 'push' : 'side'"
        class="global-menu"
        [disableClose]="true"
        [opened]="!mobileQuery.matches">
        <div class="logo" (click)="onLogoClick()">
            <mat-icon aria-hidden="false" inline [attr.aria-label]="'app_name' | translate">cloud_circle</mat-icon>
        </div>
        <app-main-menu></app-main-menu>
        <span class="app-version">{{ version }}</span>
    </mat-sidenav>
    <mat-sidenav-content [class.is-nav-loading]="isNavigating()">
        <ng-content select="[content]"></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
